import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import { reviews, companyInfo } from '../mock';

const Reviews = () => {
  const handleGoogleReviews = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=Stark+Hausmeisterservice+Dillingen', '_blank');
  };

  return (
    <section id="reviews" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-yellow-100 rounded-full px-6 py-3 mb-6">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="font-bold text-slate-900">{companyInfo.rating}</span>
            <span className="text-slate-700">auf Google</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Das sagen unsere Kunden
          </h2>
          <p className="text-xl text-slate-600">
            Überzeugen Sie sich von der Qualität unserer Arbeit
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {reviews.map((review) => (
            <Card
              key={review.id}
              className="hover:shadow-xl transition-shadow duration-300 border-slate-200"
            >
              <CardContent className="p-6">
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-slate-700 mb-6 leading-relaxed">
                  "{review.text}"
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                  <div>
                    <div className="font-semibold text-slate-900">{review.author}</div>
                    <div className="text-sm text-slate-500">{review.date}</div>
                  </div>
                  <div className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center text-white font-bold">
                    {review.author.charAt(0)}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button
            onClick={handleGoogleReviews}
            size="lg"
            variant="outline"
            className="border-slate-300 text-slate-900 hover:bg-slate-50"
          >
            Weitere Bewertungen auf Google ansehen
            <ExternalLink className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
